import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import PageMeta from "./PageMeta";

export default function MarkdownPage({ title, description, markdownFile }) {
    const [content, setContent] = useState("");

    useEffect(() => {
        fetch(markdownFile)
            .then((res) => res.text())
            .then(setContent)
            .catch(console.error);
    }, [markdownFile]);

    return (
        <>
            <PageMeta title={title} description={description} />
            <section className="pt-32 lg:pt-44 pb-10 bg-linear-to-b from-gray-50 to-white">
                <div className="max-w-4xl mx-auto px-4 lg:px-6">
                    <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
                        {title.replace(" – CV Box", "")}
                    </h1>
                    <p className="text-gray-600 text-lg">Last updated: April 2026</p>
                </div>
            </section>
            <div className="max-w-4xl mx-auto px-4 lg:px-6 pb-20">
                <div className="prose prose-gray max-w-none">
                    <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
                </div>
            </div>
        </>
    );
}